import PageHeader from '../../components/PageHeader';
import Sidebar from '../../components/Sidebar';
import Transitions from '../../components/Transition';
import ClientUserForm from './components/ClientUserForm';

export default function NewClientUser() {
  return (
    <>
      <Sidebar active="ClientUsers" />
      <Transitions>
        <PageHeader
          title="Novo usuário"
          link="/clientUsers"
        />
        <ClientUserForm />
      </Transitions>
    </>
  );
}
